import {useEffect, useState} from "react";
import "./style.scss";
import SplashScreen from "../splashscreen";
import ErrorBoundary from "../errorboundary";
import GameStart from "../gamestart";
import {connect} from "react-redux";
import {intialize} from "../../store/intialize/operations";
import CuLayout from "../../utils/gameLayout";
import {Alert} from "@material-ui/lab";
import Languageselection from "../languageselection";
import ConsentScreen from "../consentScreen";

function App({isLoaded, intialize, userSelectedLanguage, mobileNumber}) {
  const [failedIntilize, setFailedIntilize] = useState(false);
  const [isGameComplete, setIsGameComplete] = useState(false);
  // const [token, setToken] = useState("");
  const [gameConsent, setGameConsent] = useState(false);

  const [msg, setMessage] = useState(
    `Couldn't load the request. Please check your internet connection and retry`
  );

  useEffect(() => {
    const token = mobileNumber || '';
    intialize(success, failure, token);
    // eslint-disable-next-line
  }, []);

  const success = () => {
    setFailedIntilize(false);
    setIsGameComplete(false);
  };

  const failure = (err) => {
    setMessage("You have already completed the game!");
    setFailedIntilize(true);
    setIsGameComplete(true);
  };

  // const handleClick = (currentToken) => {
  //   intialize(success, failure, currentToken || token);
  // };

  if (failedIntilize) {
    return (
      <ErrorBoundary>
        <div className="app_alert">
          {isGameComplete ? (
            <div className="app_alert_complete">
              <div className="app_alert_complete_content">
                <p className="app_alert_complete_title">CONGRATULATIONS!</p>
                <p className="app_alert_complete_subtitle">
                You've completed this game
                </p>
              </div>
            </div>
          ) : (
            <Alert severity="error">
              <h3>{msg}</h3>
            </Alert>
          )}
        </div>
      </ErrorBoundary>
    );
  } else {
    return (
      <>
        <ErrorBoundary>
          {!isLoaded ? (
            <SplashScreen />
          ) : (
            <>
              {gameConsent ? (
                <SelectedLanguage language={userSelectedLanguage} />
              ) : (
                <ConsentScreen setGameConsent={setGameConsent} />
              )}
            </>
          )}
        </ErrorBoundary>
      </>
    );
  }
}

const SelectedLanguage = ({language}) => {
  return (
    <>
      {language ? (
        <>
          <CuLayout>
            <GameStart />
          </CuLayout>
        </>
      ) : (
        <Languageselection />
      )}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    isLoaded: state.intialize.isLoaded,
    languages: state.intialize.languages,
    userSelectedLanguage: state.trackingUser.lang,
    mobileNumber: state.trackingUser.user && state.trackingUser.user.number,
  };
};

const mapDisPatchToProps = (dispatch) => {
  return {
    intialize: (success, failure, token) =>
      dispatch(intialize(success, failure, token)),
  };
};

export default connect(mapStateToProps, mapDisPatchToProps)(App);
